import React, { Component } from 'react';

const BASE = '/idea-bet.live/theme/1ufaai/';

class EventPage extends Component {
    render() {
        return (
            <div className="x-social-share-index-content-container x-default-bg-center" style={{ paddingTop: '72px', minHeight: '100vh' }}>
                <link rel="stylesheet" href={BASE + 'style.css'} />

                <div className="-x-headline-title text-center" style={{ padding: '40px 16px 16px' }}>
                    <h1 style={{ color: '#EFD0A0', fontSize: '24px', fontWeight: '700' }}>แชร์แลกทรัพย์ แชร์ปั๊บ รับปุ๊บ</h1>
                    <p style={{ color: '#ccc' }}>รวมกิจกรรมสุดปัง เอาใจสมาชิก พร้อมสิทธิพิเศษ ที่นี่ที่เดียว</p>
                </div>

                <div className="container">
                    {/* Empty state */}
                    <div style={{ background: 'rgba(0,0,0,0.5)', borderRadius: '12px', padding: '40px', textAlign: 'center', marginBottom: '32px' }}>
                        <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
                        <p style={{ color: '#EFD0A0', fontSize: '16px', fontWeight: '600' }}>ยังไม่มีกิจกรรมให้คุณเข้าร่วมได้ในขณะนี้</p>
                        <p style={{ color: '#aaa' }}>โปรดติดตามกิจกรรมต่างๆได้ที่เว็บไซต์เรา เร็วๆนี้</p>
                    </div>

                    {[
                        {
                            title: 'แจกเครดิตฟรี สมาชิกใหม่ UFAgrand168 รับโบนัสฟรีทันที',
                            body: 'หากพูดถึงเว็บไซต์แทงบอลที่แจกเครดิตฟรีแล้ว ส่วนใหญ่มักจะต้องการเว็บไซต์ที่เล่นกิจกรรมแล้วจ่ายเครดิตจริง โดยนักเดิมพันส่วนใหญ่ต้องการโบนัสเพื่อใช้ในการเริ่มพนันบอลโดยไม่ต้องลงทุน และสามารถเพิ่มโอกาสในการทำกำไรได้เป็นอย่างดี ปฏิเสธไม่ได้เลยว่าการแทงบอลจะได้รับความนิยมสูงสุดอันดับต้น ๆ และเป็นส่วนหนึ่งของกิจกรรมในชีวิตประจำวันไปแล้ว',
                        },
                        {
                            title: 'จุดเด่นที่ทำให้ UFAgrand168 ขึ้นมาครองอันดับ 1',
                            body: 'รูปแบบใหม่ ดีไซน์ทันสมัย ใช้งานง่ายกว่าเดิม เหมาะสำหรับมือใหม่ • ร่วมสนุกกับเว็บตรงที่ไม่ผ่านคนกลาง เดิมพันกับบริษัทแม่โดยตรง ไม่ต้องเสี่ยงกับการถูกโกง • ราคาบอล 4 ตังค์ ค่าคอม 0.5 ซึ่งเป็นราคาดีที่สุดในตอนนี้ • เล่นได้ไม่อั้น เท่าไหร่ก็จ่าย • ระบบฝาก-ถอนออโต้ ทำรายการได้เองไม่ต้องผ่านแอดมิน',
                        },
                        {
                            title: 'สมัคร UFAgrand168 วันนี้รับโบนัสฟรีเฉพาะสมาชิกเท่านั้น',
                            body: 'หนึ่งในสิทธิพิเศษที่เหนือกว่าผู้ให้บริการรายอื่น ๆ แล้วยังสามารถรับเครดิตฟรีได้อย่างง่ายดาย โดยปราศจากเงื่อนไขที่ยุ่งยาก เพียงสมัคร UFAgrand168 และทำการแชร์ผ่าน Facebook เท่านั้น ยิ่งแชร์ทุกวัน ก็ได้รับทุกวัน ที่สำคัญไม่จำกัดจำนวนวันอีกด้วย',
                        },
                        {
                            title: 'กิจกรรม UFAgrand168 รับเครดิตฟรี เข้าเดิมพันกีฬา',
                            body: 'เครดิตฟรีสำหรับเว็บแทงบอล กำลังเป็นที่นิยมกันอย่างมากในตอนนี้ ด้วยเหตุที่ว่าคนส่วนใหญ่มักให้ความสนใจกับการเล่นกีฬามากขึ้น ทางเราจึงได้เลือกเอากีฬาเหล่านั้นมาให้ได้เลือกเดิมพันเพื่อความสนุกสนาน ความบันเทิง และช่วยให้ท่านได้สร้างรายได้ไปกับเรา UFAgrand168 เป็นแหล่งรวมเกมพนันที่ดีที่สุด',
                        },
                    ].map((s, i) => (
                        <div key={i} style={{ border: '1px solid #b8962e', borderRadius: '12px', padding: '22px', marginBottom: '16px', background: 'rgba(0,0,0,0.3)' }}>
                            <h3 style={{ color: '#EFD0A0', fontSize: '17px', marginBottom: '10px' }}>{s.title}</h3>
                            <p style={{ color: '#ccc', lineHeight: '1.8', fontSize: '14px', margin: 0 }}>{s.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
export default EventPage;
